import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'productRowSpan',
    standalone: true
})
export class ProductRowSpanPipe implements PipeTransform {
    transform(rowSpan?: number, colSpan?: number, isLandscape?: boolean): number {
        return productRowSpan(rowSpan, colSpan, isLandscape);
    }
}

export function productRowSpan(rowSpan = 1, colSpan = 1, isLandscape = false): number {
    return isLandscape ? rowSpan ?? 1 : colSpan ?? 1;
}
